import React from 'react';
import Modal from 'olive-react-myoneui/lib/Modal';
import Button from 'olive-react-myoneui/lib/Button';
import { logout } from '../../../utils/auth';
import { readCookie } from '../../../utils/cookie';

const MobileUpdateModal = ({title, message}) => {
  const preview_as_user = readCookie("preview_as_user");
  const handlelogout = (e) => {
    e.preventDefault();
    const origin = window.location.origin;
    logout()
    if (preview_as_user === "preview_as_user") {
      window.location.assign(`${origin}/logout/admin_as_user/`);
    }
    else {
      window.location.assign(`${origin}/logout`);
    }
  }

  return (
    <Modal centered show={true} contentClassName={'p-4'}>
        <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body><p>{message}</p></Modal.Body>
        <Modal.Footer>
          <Button variant={"orange"} onClick={handlelogout}>
             {'Required to Re-login'}
          </Button>
        </Modal.Footer>
    </Modal>
  );
}

export default MobileUpdateModal;
